<template>
  <div id="ecco-side-menu">
    <div class="side-menu-scroll">
      <div v-for="section in sideMenuItems" :key="section.subheader">
        <v-list dense shaped dark color="#3e523c">
          <v-subheader>{{ section.subheader }}</v-subheader>
          <v-list-item link v-for="item in section.items" :key="item.name" :to="{ name: item.name }">
            <v-list-item-content>
              <v-list-item-title>
                {{item.text}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="mx-4"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  data: () => ({
    selectedItem: 1,

    sideMenuItems: [
      {
        subheader: 'MANAGEMENT',
        items: [
          {
            text: 'SMS Configuration',
            name: 'InstructorTableRoute',
          },
          {
            text: 'SMS Broadcast',
            name: 'SMSBroadcastRoute',
            exact: true,
          },
          {
            text: 'Class Types',
            name: 'ClassTypesRoute',
            exact: true,
          },
          {
            text: 'QR Codes & Nametags',
            name: 'QrCodesNametagsRoute',
            exact: true,
          }
        ]
      },
      {
        subheader: 'MARKETING',
        items: [
          {
            text: 'Intro Offers CRM',
            name: 'IntroOffers5DayRoute',
            exact: true,
          },
          {
            text: 'In-app Ads',
            name: 'InAppAdRoute',
            exact: true,
          },
          {
            text: 'Fifth Tab Posts',
            name: 'FifthTabPostsRoute',
            exact: true,
          },
          {
            text: 'Challenges',
            name: 'ChallengeSignupRoute',
            exact: true,
          },
          {
            text: 'Customer Journals',
            name: 'CustomerJournalRoute',
            exact: true,
          }
        ]
      },
      {
        subheader: 'WORKFLOWS',
        items: [
          {
            text: 'Workshop Credits',
            name: 'WorkshopCreditRoute',
            exact: true,
          },
        ]
      },
      {
        subheader: 'REPORTS',
        items: [
          {
            text: 'Autolayout',
            name: 'AutolayoutRoute',
            exact: true,
          },
          {
            text: 'Landing Analytics',
            name: 'AnalyticsLandingRoute',
            exact: true,
          },
        ]
      },
      {
        subheader: 'TOOLS',
        items: [
          {
            text: 'RYL Sync',
            name: 'RylSyncRoute',
            exact: true,
          },
          {
            text: 'URL Generator',
            name: 'UrlGeneratorRoute',
            exact: true,
          },
          {
            text: 'Gift Cards',
            name: 'GiftCardConfigListRoute',
            exact: true,
          }
        ]
      }
    ],
  }),
  computed: {
    isAuthenticated() {
      return this.$store.state.auth.accessToken
    },
  },
  methods: {
    goTo(name) {
      this.$router.push({ name })
    },
  },
}
</script>

<style lang="sass">
#ecco-side-menu
  background-color: #3e523c
  position: fixed
  top: 64px
  height: calc(100vh - 64px)
  width: 240px
  overflow-y: auto

#side-menu-scroll
  background-color: #3e523c

.theme--dark.v-application
  #side-menu
    background-color: #1E1E1E

.theme--light.v-application
  #side-menu
    background-color: #FFFFFF
    box-shadow: 1px 3px 14px rgba(0,0,0,0.2)
</style>